module.exports = __webpack_public_path__ + "img/ad4f34e3a95ff2a4003ffd1372231fdf.png";